import React, {useState, useEffect} from 'react';
import {useViewportMediaQuery} from 'hooks';
import CmsService from 'services/CMS';
import TagManagerService from 'services/TagManager';
import ImageLoad from 'components/ImageLoad';
import Link from 'components/Link';
import style from './style.scss';//NOSONAR

const GridTextImageMedium = (props) => {
    const {data, dateServer} = props; 
    if(!data || !data.active) return false;
    const [active, setActive] = useState(false);
    const [visible, setVisible] = useState(false);
    const isMobile = useViewportMediaQuery('768');

    const {
        title,
        text,
        color,
        image_desktop,
        image_mobile,
        url
    } = data ? data : {};

    useEffect(() => {
        const validateDate = CmsService.validDatesItem(data, dateServer);

        if(validateDate) {
            setVisible(validateDate);
        }
    },[]);

    const _open = () => {
        setActive(prevState => !prevState);
    }

    useEffect(() => {
        promotionView();
    }, [])

    let imageResponsive = {
        840: image_mobile ? image_mobile : '',
        1440: image_desktop ? image_desktop : ''
    };

    const promotionView = () => {
        let gtm = [];
        gtm.push({
            id: data.image_desktop  ? data.image_desktop : data.title,
            name: data.title ? data.title : data.image_desktop ,
            position: 'slot' + data.position || '',
            creative: `Vitrina imagen M ${data.position || ''} - ${data.title || ''}`
        })
        TagManagerService.promotionsImpressions(gtm)
    }

    const reDirectUrl = () => {
        window.location.href = isMobile ? url : '';
    }

    const sendGtm = () => {
        const promotionClick = {
            id: data.image_desktop  ? data.image_desktop : data.title,
            name: data.title ? data.title : data.image_desktop ,
            position: 'slot' + data.position || '',
            creative: `Vitrina imagen M ${data.position || ''} - ${data.title || ''}`
        };

        TagManagerService.interaction(data.title, 'Ver más', 'Vitrina imagen M');
        
        TagManagerService.promotionsClick(promotionClick);
    }

    if(!visible) return false;

    return(
        <section className='grid-text-image-medium'>
            {isMobile &&<div className='grid-text-image-medium-container-mobile'>
                <h1 className='grid-text-image-medium-title'>{title}</h1> 
                {url && <Link to={url} className='grid-text-image-medium-link' onClick={sendGtm} >Ver más</Link>}
            </div>}
            
            <div className={'grid-text-image-medium-container ' + (color ? color : '')  + (active ? ' open ' : ' close ') }>
                {!isMobile && <h1 className='grid-text-image-medium-title' >{title}</h1>}
                
                <span className='grid-text-image-medium-container-text' >{text}</span>
                {!isMobile && url && <Link to={url} className={'grid-text-image-medium-link-not-mobile' + ((color === 'isa-grey') ? ' primary-btn' : '' )} onClick={sendGtm}>Ver más</Link>}
                    
                {isMobile && text && <div className='grid-text-image-medium-container-read-more-button'>
                    <button className='grid-text-image-medium-read-more-button' onClick={_open}>{active ? 'Ocultar'  : 'Ver todo'}</button>
                </div>}
            </div>
            <ImageLoad src={image_desktop} srcSet={imageResponsive}  alt={image_desktop} onClick={reDirectUrl}  />
        </section>
    )
}

export default GridTextImageMedium;